import type { TFunction } from 'i18next';

import type { Community } from '~/interfaces/community';

export const getCommunityDescription = (community: Pick<Community, 'description'> | null, t: TFunction): string =>
  community?.description?.trim() || t('community.join.banner_description');
